import React, { FC } from 'react';
import './FilterToggleButton.css';
import { FaSlidersH } from '@/Shared/Lib/UI/Icons';

interface FilterToggleButtonProps {
	activeFilterCount: number;
	onClick: () => void
}

const FilterToggleButton: FC<FilterToggleButtonProps> = ({ onClick, activeFilterCount = 0 }) => (
	<div className="FilterToggleButton flex-row" data-testid="FilterToggleButton">

		<div className='DataListFilter__toggle'>Filtres({activeFilterCount})</div>
		<button className='DataListFilter__toggle-icon' onClick={onClick} aria-label="Ouvrir les filtres">
			<FaSlidersH />
		</button>
	</div>
);

export default FilterToggleButton;
